'use client';

import { useQuery } from '@tanstack/react-query';
import api from '@/app/lib/axios';

export type FeatureMap = Record<string, boolean>;

export const FEATURES_QUERY_KEY = ['features'];

// Feature flags (games + exchange on/off) from GET /features. Unknown or
// not-yet-loaded flags default to enabled — the backend enforces the real gate.
export function useFeatures() {
    const { data, isLoading } = useQuery<FeatureMap>({
        queryKey: FEATURES_QUERY_KEY,
        queryFn: async () => {
            const response = await api.get<{ features: FeatureMap }>('features');
            return response.data.features;
        },
        staleTime: 30_000,
        refetchInterval: 60_000,
    });

    const isEnabled = (feature: string) => data?.[feature] ?? true;

    return { features: data, isEnabled, isLoading };
}
